<template>
    <v-combobox label="리스트" placeholder="Tab을 누르면 항목이 추가됩니다" v-model="list" item-text="term" small-chips multiple v-bind="$attrs" @change="setListItems">
        <template v-slot:selection="{ attrs, item, parent }">
            <v-chip v-bind="attrs" :input-value="!item.isIt" small outlined class="rounded-0" color="grey darken-4" text-color="grey darken-4" @click="(item.isIt = !item.isIt) && emit()">
                <span class="pr-2"> {{ item.term }} </span>
                <v-icon small @click="(parent.selectItem(item) || true) && emit()"> $delete </v-icon>
            </v-chip>
        </template>
    </v-combobox>
</template>

<script>
export default {
    props: ["value"],
    data: () => ({
        list: [],
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.list = [...this.value];
        },
        emit() {
            this.$emit("input", this.list);
        },
        setListItems(list) {
            list.forEach((term) => {
                if (typeof term == "string") {
                    const index = list.findIndex((item) => item == term);
                    list.splice(index, 1, { term, isIt: false });
                }
            });
            this.emit();
        },
    },
};
</script>

<style>
</style>